import { Label } from '@/components/ui/label'
import { Switch } from '@/components/ui/switch'
import { Send, XCircle } from 'lucide-react'
import { useId } from 'react'

type CustomerNotificationSwitchProps = {
  notifyCustomer: boolean
  onNotifyCustomerChange: (notifyCustomer: boolean) => void
  notificationLabel?: string | null
  disabled?: boolean
}

function CustomerNotificationSwitch({
  notifyCustomer,
  onNotifyCustomerChange,
  notificationLabel = null,
  disabled = false,
}: CustomerNotificationSwitchProps) {
  const switchId = useId()
  const NotificationIcon = notifyCustomer ? Send : XCircle
  const resolvedNotificationLabel =
    notificationLabel ?? (notifyCustomer ? 'Notify the customer' : 'Will not notify the customer')

  return (
    <div className="flex items-center justify-between gap-3">
      <Label
        htmlFor={switchId}
        appearance="choice"
        tone="muted"
        weight="normal"
        leading="normal"
        className="min-w-0"
      >
        <NotificationIcon
          className={`size-4 shrink-0 ${notifyCustomer ? 'text-interaction' : 'text-destructive'}`}
        />
        <span className="min-w-0">{resolvedNotificationLabel}</span>
      </Label>
      <Switch
        id={switchId}
        checked={notifyCustomer}
        disabled={disabled}
        aria-label="Notify the customer"
        onCheckedChange={onNotifyCustomerChange}
      />
    </div>
  )
}

export { CustomerNotificationSwitch }
